import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { FormGroup } from '@angular/forms';
import { Cart } from '../../core/interfaces/cart.interface';

@Injectable({
  providedIn: 'root'
})

export class CartService {
  items: Cart[] = [];

  private refresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient,
              private urlHelper: UrlHelperService) { }

  public getRefresh(): Observable<boolean> {

    return this.refresh.asObservable();
  }

  public setRefresh(value: boolean): void {

    this.refresh.next(value);
  } 


  addToCart(data: Cart): Observable <BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "Item/ReserveItem";
    return this.http.post<BooleanResult>(url, data);
  }

  getCartItems(): Observable<Array<any>> {

    var url = this.urlHelper.getApiUrl() + "Item/GetCartItems";
    return this.http.get<any[]>(url);
  }

  getTimedOutCartItems(): Observable<Array<any>> {

    var url = this.urlHelper.getApiUrl() + "Item/GetTimedOutCartItems";
    return this.http.get<any[]>(url);
  }

  getTimedOutCartMiscItems(): Observable<Array<any>> {

    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem/GetTimedOutCartMiscItems";
    return this.http.get<any[]>(url);
  }

  removeCartItem(itemId: number, addonOptionId: number): Observable<BooleanResult> {
    var data = { itemId, addonOptionId };
    var url = this.urlHelper.getApiUrl() + "Item/RemoveItemFromCart";
    return this.http.post<BooleanResult>(url, data);
  }

  updateCartItem(itemId: number, quantity: number, addonOptionId: number): Observable<BooleanResult> {
    var data = { itemId, quantity, addonOptionId };
    var url = this.urlHelper.getApiUrl() + "Item/UpdateItem";
    return this.http.post<BooleanResult>(url, data);
  }

  updateCartMiscItem(miscellaneousItemId: number, quantity: number): Observable<BooleanResult> {
    var data = { miscellaneousItemId, quantity };
    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem/UpdateCartMiscItem";
    return this.http.post<BooleanResult>(url, data);
  }

  showCart(value: any) {
    this.setRefresh(true);
    var wrapper = document.getElementsByClassName('wrapper')[0];
    wrapper.classList.toggle('opened');

  }

  hideCart(value: any) {
    var wrapper = document.getElementsByClassName('wrapper')[0];
    wrapper.removeAttribute('wrapper');
  }


  getMiscellaneousItemCartItems(): Observable<Array<any>> {

    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem/GetMiscelleousCartItems";
    return this.http.get<any[]>(url);
  }

  addMiscellaneousItemToCart(data: Cart): Observable<BooleanResult> {
    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem/ReserveMiscelleousItem";
    return this.http.post<BooleanResult>(url, data);
  }

  removeMiscCartItem(miscellaneousItemId: number): Observable<BooleanResult> {
    var data = { miscellaneousItemId };
    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem/RemoveMiscItemFromCart";
    return this.http.post<BooleanResult>(url, data);
  }

  public clearCartItems(organizationId: number) {
    //clear out everything in the organization's cart before switching to the new organization
    var data = { organizationId };
    var url = this.urlHelper.getApiUrl() + "Item/ClearCartItems";
    return this.http.post<BooleanResult>(url, data);
  }

}
